import { render, staticRenderFns } from "./GenderDisplayText.vue?vue&type=template&id=1317484e&scoped=true&"
import script from "./GenderDisplayText.vue?vue&type=script&lang=js&"
export * from "./GenderDisplayText.vue?vue&type=script&lang=js&"
import style0 from "./GenderDisplayText.vue?vue&type=style&index=0&id=1317484e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1317484e",
  null
  
)

component.options.__file = "GenderDisplayText.vue"
export default component.exports